import { heroData } from '@/mocks/homeData';

export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center pt-[72px] overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-primary-50/30"></div>

      <div className="relative w-full px-4 md:px-6 py-12 md:py-20">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
            <div className="flex-1 w-full text-center lg:text-left">
              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-2 mb-5">
                {heroData.tags.map((tag) => (
                  <span
                    key={tag}
                    className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-primary-100/80 text-primary-700 whitespace-nowrap"
                  >
                    {tag}
                  </span>
                ))}
              </div>

              <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading text-foreground-950 leading-tight">
                丫丫漫画
                <span className="block text-primary-600 mt-2">
                  下拉式免费漫画阅读平台
                </span>
              </h1>

              <p className="mt-3 text-lg md:text-xl text-foreground-600 font-medium">
                随时随地，下拉即读，畅享全集
              </p>

              <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0">
                丫丫漫画是国内领先的在线漫画阅读平台，覆盖韩漫、日漫、国漫全品类海量资源。独创的下拉式翻页阅读模式，让漫画阅读如行云流水般自然流畅——只需轻轻下滑，即可无缝衔接下一页内容，彻底告别繁琐的翻页操作。平台每日更新超过200话，十万余部漫画全集免费畅读，追更、补番、发现新作一站搞定。
              </p>

              <div className="mt-6 flex flex-wrap items-center justify-center lg:justify-start gap-6">
                {heroData.stats.map((stat) => (
                  <div key={stat.label} className="text-center">
                    <span className="block text-2xl md:text-3xl font-heading text-primary-600">
                      {stat.value}
                    </span>
                    <span className="block text-xs text-foreground-500 mt-1">
                      {stat.label}
                    </span>
                  </div>
                ))}
              </div>

              <div className="mt-8 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
                <a
                  href="#cards"
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 font-semibold text-sm rounded-full hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-book-open-line text-lg"></i>
                  开始阅读
                </a>
                <a
                  href="#app"
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector('#app')?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="inline-flex items-center gap-2 px-8 py-3.5 bg-background-50 text-foreground-800 font-medium text-sm rounded-full border border-background-300 hover:border-primary-300 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-download-2-line text-lg"></i>
                  下载APP
                </a>
              </div>
            </div>

            <div className="flex-1 w-full flex justify-center lg:justify-end">
              <div className="relative w-full max-w-[420px] aspect-[4/5] rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20warm%20and%20cozy%20artistic%20illustration%20of%20a%20person%20comfortably%20reading%20a%20colorful%20manga%20on%20a%20tablet%20in%20a%20soft%20ambient%20living%20room%20setting%2C%20warm%20orange%20and%20cream%20color%20palette%2C%20stylized%20modern%20flat%20illustration%20with%20floating%20comic%20speech%20bubbles%20and%20panel%20elements%2C%20editorial%20quality%2C%20relaxed%20atmosphere%2C%20clean%20composition&width=840&height=1050&seq=hero-main-visual&orientation=portrait"
                  alt="丫丫漫画下拉式在线阅读体验"
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-900/10 to-transparent"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}